import { useQueryClient } from '@tanstack/react-query';

/**
 * Refresca los contadores del pipeline tras un envío a Binary.
 *
 * Hace `refetchQueries` y NO `invalidateQueries` a propósito: mientras el job
 * corre puede haber un fetch de contadores en vuelo (arrancado en un tick
 * intermedio) que capturó un estado parcial. `invalidateQueries` se dedup con
 * ese fetch en curso y no lo reemplaza, así que la lista quedaba mostrando
 * "pendiente de alta" después de cerrar el modal.
 */
export function useRefrescarPipeline(): () => void {
  const qc = useQueryClient();
  return () => {
    qc.refetchQueries({ queryKey: ['legajos-listos-counts'] });
    qc.refetchQueries({ queryKey: ['legajos-listos-detalle'] });
    qc.refetchQueries({ queryKey: ['dashboard-global'] });
    // La lista de padrones muestra los contadores OK/error de cada uno, y
    // Adherentes el estado de envío: también cambian con el envío. Estas no
    // están montadas mientras corre el job, así que `invalidate` alcanza y no
    // dispara un fetch de más.
    qc.invalidateQueries({ queryKey: ['padrones'] });
    qc.invalidateQueries({ queryKey: ['adherentes'] });
  };
}
